import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ApiService } from '@services/api.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { DataHelper } from '@helpers/data.helper';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService } from '@services/localization.service';
import { TranslatePipe } from '@pipes/translate.pipe';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { passwordRegex } from '@environments/environment';

@Component({
  selector: 'recover-password-component',
  templateUrl: '../sharedTemplates/recover-password.component.html',
})
export class RecoverPassword implements OnInit {
  private passwordRegex = passwordRegex;
  recoverPasswordDatas: UntypedFormGroup;
  recovercPasswordDataRaw: any;
  recoverykey = '';
  langId = '';
  constructor(
    public _UiHelper: UiHelper,
    private _ApiService: ApiService,
    private _DataHelper: DataHelper,
    public _Router: Router,
    private route: ActivatedRoute,
    private _ActivatedRoute: ActivatedRoute,
    private _LocalizationService: LocalizationService,
    public _LZ: LocalizationService,
    private _FormBuilder: UntypedFormBuilder,
    private _UserHelper: UserHelper
  ) {
    this.recoverPasswordDatas = _FormBuilder.group({
      newPassword: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.pattern(this.passwordRegex)]),
      reNewPassword: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.pattern(this.passwordRegex)]),
    });
  }

  ngOnInit() {
    this.recoverykey = this.route.snapshot.queryParams['s'];
    this.langId = this.route.snapshot.queryParams['l'];

    this.recoverPasswordDatas.valueChanges.subscribe(x => {
      this.recovercPasswordDataRaw = x;
    });
  }

  submitRecoverPasswordData() {
    const translator = new TranslatePipe(this._LocalizationService);
    this._ApiService.recoverPassword(this.recovercPasswordDataRaw, this.recoverykey, this.langId).then(result => {
      if (result.code !== '') {
        if (result.code === 'error') {
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code === 'errorcode') {
          const t_message = translator.transform(result.message, null);
          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code === 'success') {
          const t_message = translator.transform(result.message, null);
          this._UiHelper.successSnackBar(t_message, '');
          this.recoverPasswordDatas.controls.newPassword.disable();
          this.recoverPasswordDatas.controls.reNewPassword.disable();
        }
      }
    });
  }
}
